<template>
  <div class="rolesManagement">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>设置</el-breadcrumb-item>
      <el-breadcrumb-item>分享设置列表管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="boxLayout">
      <el-form
        :inline="true"
        :model="customerGroupForm"
        class="demo-form-inline"
      >
        <el-form-item label="关键字" class="search_keyword">
          <el-input
            placeholder="请输入内容"
            v-model="customerGroupForm.search_keyword"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="getList">
            查询
          </el-button>
          <el-button size="medium" @click="clear">清空</el-button>
          <el-button size="medium">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="boxLayout mg-t-20">
      <div class="text-right mg-b-20">
        <el-button type="primary" @click="onAdd"> 添加分享配置 </el-button>
      </div>
      <el-table
        class="mg-t-20"
        ref="multipleTable"
        :data="tableData.data"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column
          label="分享封面"
          prop="img_url"
          :align="'center'"
          width="200"
        >
          <template slot-scope="scope">
            <img style="height: 120px" :src="scope.row.img_url" />
          </template>
        </el-table-column>
        <el-table-column
          label="分享类型"
          prop="type"
          :align="'center'"
          width="120"
        />
        <el-table-column label="分享名称" prop="name" :align="'center'" />
        <el-table-column label="分享描述" prop="desc" :align="'center'" />
        <!-- <el-table-column
          label="状态"
          :align="'center'"
          prop="status"
          width="120"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" style="color: #2ed477">
              启用
            </span>
            <span v-else>禁用</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="create_time"
          label="添加时间"
          :align="'center'"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="操作"
          :align="'center'"
          width="150"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row)" type="text" size="small">
              编辑
            </el-button>
            <el-button @click="deleted(scope.row)" type="text" size="small">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="tableData.total"
        :per_page="tableData.per_page"
        :current_page="tableData.current_page"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
      <EditShare ref="shareRef" @ok="getList" />
    </div>
  </div>
</template>
<script>
import pagination from "../../../components/pagination.vue";
import EditShare from "./edit-share.vue";
export default {
  name: "testManagement",
  components: {
    pagination,
    EditShare,
  },
  data() {
    return {
      customerGroupForm: {
        search_keyword: "",
      },
      tableData: {
        data: [],
        per_page: 10,
        current_page: 1,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    onAdd() {
      this.$refs.shareRef.open({});
    },
    onEdit(row = {}) {
      this.$refs.shareRef.open(row);
    },
    clear() {
      for (let i in this.customerGroupForm) {
        this.customerGroupForm[i] = "";
      }
      this.getList();
    },
    // 列表
    getList() {
      const { per_page, current_page } = this.tableData;
      const data = {
        ...this.customerGroupForm,
        per_page,
        current_page,
      };
      const params = Object.keys(data)
        .map((key) => `${key}=${data[key]}`)
        .join("&");
      const url = `https://time.api.boyalife.cn/v1/cms/ShareSettingV2/List?${params}`;
      this.axios({
        method: "get", //请求方法
        headers: {
          "Content-Type": "text/html;charset=UTF-8",
          "X-Access-Token": this.storage.get("__token"),
          Authorization: `Bearer ${this.storage.get("__token")}`,
        },
        url,
      })
        .then((res) => {
          this.tableData = res.data.result;
        })
        .catch((err) => {
          this.$message.error(err.response.data.error.message);
        });
    },
    deleted(row) {
      this.$confirm("删除后无法恢复，确定删除当前分享设置吗？", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
        dangerouslyUseHTMLString: true,
      }).then(() => {
        this.axios({
          method: "delete", //请求方法
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          url: ` https://time.api.boyalife.cn/v1/cms/ShareSettingV2/${row.id}`,
        })
          .then((res) => {
            this.$message.success("操作成功！");
            this.getList();
          })
          .catch((err) => {
            this.$message.error(err.response.data.error.message);
          });
      });
    },
    handleSizeChange(v) {
      this.tableData.per_page = v;
      this.getList();
    },
    handleCurrentChange(v) {
      this.tableData.current_page = v;
      this.getList();
    },
  },
};
</script>
<style scoped></style>
